<template>
  <sideBarView />

  <navbarView />

  <main class="main-sec" id="main">
    <div class="container">
      <div class="flex-bet-main mb-2">
        <div class="side-heading">
          <h6> {{ $t("auth.Profile") }}</h6>
          <p class="font13 gray-col">{{ $t("auth.main") }}</p>
        </div>
      </div>
      <div class="card-details-def">
        <div class="col-md-7 col-12">
          <v-form @submit.prevent="validProfile" v-model="valid" ref="form">
            <div class="flex-group-me mb-4">
              <div class="profile-img-cont">
                <img :src="profileImg" alt="" class="profileImg" />
                <input
                  name="image"
                  type="file"
                  id="imageInput"
                  hidden
                  accept="image/*"
                  @change="uploadImage"
                />
                <label for="imageInput" class="labelImg">
                  <i class="fa-regular fa-pen-to-square"></i>
                </label>
              </div>
            </div>
            <div class="mb-4">
              <div class="flex-big-gap">
                <div class="all-container-type">
                  <h6 class="mb-3 requiredInputLabel" >{{ $t("auth.accountType") }}</h6>
                  <div class="flex-sm-gap">
                    <input
                      type="radio"
                      :checked="type == 'company'"
                      value="company"
                      name="type"
                      id="company"
                      class="mainRadio"
                    />
                    <label for="company">{{ $t("auth.company") }}</label>
                  </div>
                </div>
                <div class="all-container-type">
                  <h6 class="styleOnly mb-3">styleOnly</h6>
                  <div class="flex-sm-gap">
                    <input
                      type="radio"
                      :checked="type == 'person'"
                      id="user"
                      name="type"
                      value="person"
                      class="mainRadio"
                    />
                    <label for="user">{{ $t("auth.person") }}</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="main-input-cont mt-1">
              <h6 class="mb-2 font14 requiredInputLabel">{{ $t("auth.userAr") }}</h6>
              <v-text-field
                type="text"
                name="name[ar]"
                v-model="name_ar"
                :rules="defaultRoles"
                :placeholder="$t('auth.userphase')"
              ></v-text-field>
            </div>
            <div class="main-input-cont mt-1">
              <h6 class="mb-2 font14 requiredInputLabel">{{ $t("auth.userEn") }}</h6>
              <v-text-field
                type="text"
                v-model="name_en"
                name="name[en]"
                :rules="defaultRoles"
                :placeholder="$t('auth.userphase')"
              ></v-text-field>
            </div>
            <div class="main-input-cont mt-1 tel-input-me">
              <div class="flex-input-con">
                <h6 class="mb-2 font14 requiredInputLabel">{{ $t("auth.phone") }}</h6>
                <router-link to="/changePhone" class="font14 gray-col mb-1"
                  >{{ $t("auth.chanephone") }}</router-link
                >
              </div>
              <v-text-field
                v-model="phone"
                class="noPointer"
                readonly
                type="number"
                name="phone"
                min="0"
                :rules="phoneRules"
                :placeholder="$t('auth.phoneplace')"
              ></v-text-field>
              <div class="drop-countries noPointer">
                <Dropdown
                  v-model="selectedCountry"
                  :options="countries"
                  optionLabel="name"
                >
                  <template #value="slotProps">
                    <div v-if="slotProps.value" class="flex-group-me">
                      <img
                        :alt="slotProps.value.label"
                        :src="slotProps.value.image"
                        :class="`mr-2 flag flag-${slotProps.value?.key.toLowerCase()}`"
                        style="width: 24px"
                      />
                      <div>{{ slotProps.value?.key }}</div>
                    </div>
                    <span v-else>
                      {{ slotProps.placeholder }}
                    </span>
                  </template>
                  <template #option="slotProps">
                    <div class="flex-group-me">
                      <img
                        :alt="slotProps.option.label"
                        :src="slotProps.option.image"
                        :class="`mr-2 flag flag-${slotProps.option.key.toLowerCase()}`"
                        style="width: 24px"
                      />
                      <div>{{ slotProps.option?.key }}</div>
                    </div>
                  </template>
                </Dropdown>
              </div>
            </div>
            <div class="main-input-cont mb-4">
              <h6 class="mb-2 font14 requiredInputLabel">{{ $t("auth.city") }}</h6>
              <Dropdown
                v-model="selectedCity"
                :options="cities"
                filter
                optionLabel="name"
                :placeholder="$t('auth.cityphase')"
                :emptyFilterMessage="$t('noData.noDataToShow')"
                :emptyMessage="$t('noData.noDataToShow')"
                class="main-select"
              />
            </div>
            <div class="main-input-cont mt-1" @click="showMap = true">
              <h6 class="mb-2 font14 requiredInputLabel">{{ $t('auth.location') }}</h6>
              <v-text-field
                type="text"
                v-model="address"
                :rules="defaultRoles"
                :placeholder="$t('auth.locationPhase')"
              ></v-text-field>
              <div class="absLeft pointer-none">
                <i class="fa-solid fa-map-pin"></i>
              </div>
            </div>
            <div class="main-input-cont mt-1">
              <h6 class="mb-2 font14 requiredInputLabel">{{ $t('auth.tradeNum') }}</h6>
              <v-text-field
                type="number"
                v-model="commercial_id"
                :rules="defaultRoles"
                :placeholder="$t('auth.tradeNumphase')"
              ></v-text-field>
            </div>
            <div class="main-input-cont mt-1">
              <h6 class="mb-2 font14 requiredInputLabel">{{ $t('auth.bioAr') }}</h6>
              <v-textarea
                :rules="defaultRoles"
                v-model="bio_ar"
                name="bio[ar]"
                rows="7"
                :placeholder="$t('auth.bioArphase')"
              ></v-textarea>
            </div>
            <div class="main-input-cont mt-1">
              <h6 class="mb-2 font14 requiredInputLabel">{{ $t('auth.bioEn') }}</h6>
              <v-textarea
                :rules="defaultRoles"
                v-model="bio_en"
                name="bio[en]"
                rows="7"
                :placeholder="$t('auth.bioEnphase')"
              ></v-textarea>
            </div>

            <div class="flex-sm-gap mb-3">
              <button
                type="submit"
                :disabled="disabled"
                class="main-btn up xl mt-4"
              >
                <div v-if="!disabled">{{ $t('auth.savephase') }}</div>
                <div class="loading" role="status" v-if="disabled">
                  {{ $t('auth.saving') }}
                  <div class="spinner-small-white" v-if="disabled"></div>
                </div>
              </button>
              <router-link to="/changePasswordDash" class="main-btn up xl mt-4"
                >{{ $t('auth.chanePass') }}</router-link
              >
            </div>
          </v-form>
        </div>
      </div>
    </div>
  </main>

  <!-- Map modal  -->
  <Dialog v-model:visible="showMap" modal :style="{ width: '44vw' }">
    <h6 class="text-center py-3">{{ $t('auth.locPhase') }}</h6>
    <div class="modal-body-main">
      <div id="map" style="min-height: 300px">
        <GoogleMap
          api-key="AIzaSyCGt8Jhn_NTdYJVqlyNfH5YQUXJyngCVok"
          :autocomplete="true"
          :language="locale"
          @change-address="getAddess"
          :location="center"
        />
      </div>
      <div class="flex-group-me mt-4 mb-4">
        <button type="button" class="main-btn lg up" @click="changeLocation">
          {{ $t('auth.confirm') }}
        </button>
      </div>
    </div>
  </Dialog>
  <!-- success modal  -->
  <Dialog v-model:visible="showSuccess" modal :style="{ width: '600px' }">
    <div class="modal-body-main modal-pad">
      <div class="flex-group-me mb-3">
        <img :src="successImg" class="successImg" alt="" />
      </div>
      <h6 class="text-center color-main font19 mb-4">
        {{ $t('auth.doneEdit') }}
      </h6>
      <div class="flex-group-me mb-3">
        <router-link
          to="/editProfile"
          @click="showSuccess = false"
          class="main-btn lg up"
          >{{ $t('auth.Profile') }}</router-link
        >
        <router-link to="/dashboardHome" class="main-btn lg up bg-trans"
          >{{ $t('auth.home') }}</router-link
        >
      </div>
    </div>
  </Dialog>
</template>

<script setup>
// imports
import sideBarView from "../components/dashboard/sideBarView.vue";
import navbarView from "../components/dashboard/navbarView.vue";
import Dropdown from "primevue/dropdown";
import GoogleMap from "vue-google-maps-ui";
import Dialog from "primevue/dialog";
import { ref, onMounted } from "vue";
import axios from "axios";
import { useToast } from "primevue/usetoast";
// import { useRouter } from "vue-router";
const toast = useToast();
// const router = useRouter();
import i18n from "@/i18n";

// get locale 
const locale = i18n.global.locale;

// reactive state
const name_ar = ref("");
const needApproved = ref("");
const name_en = ref("");
const bio_en = ref("");
const bio_ar = ref("");
const commercial_id = ref("");
const type = ref("");
const disabled = ref(false);
const lat = ref(null);
const lng = ref(null);
const form = ref(null);
const center = ref({ lat: null, lng: null });
const showMap = ref(false);
const showSuccess = ref(false);
const address = ref("");
const selectedCity = ref(null);
const cities = ref([]);
const profileImg = ref(require("../assets/imgs/solia.jpg"));
const successImg = ref(require("../assets/imgs/check.png"));
const valid = ref(false);
const phone = ref("");
const defaultRoles = ref([
  (value) => {
    if (value) return true;

    return i18n.global.t(`auth.defaultValid`);
  },
]);
const phoneRules = ref([
  (value) => {
    if (value) return true;

    return i18n.global.t(`auth.phoneValid`);
  },
  (value) => {
    if (value.length >= 9) return true;

    return i18n.global.t(`auth.phoneValidnumber`);
  },
]);

const selectedCountry = ref({
  key: "+966",
  code: "SA",
  image:
    "http://saqf-sa.com/public/storage/images/countries/1704282290_8447.png",
});
const countries = ref([]);
// functions

// get profile
async function getProfile() {
  await axios
    .get("/manager/profile", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then((response) => {
      needApproved.value = response.data?.key;
      type.value = response.data.data.type;
      // selectedCountry.value.key = response.data.data.country_code;
      // selectedCountry.value = countries.value.find(
      //   (country) => country.key?.includes(response.data.data?.country_code)
      // )

      selectedCountry.value = {
        key: response.data.data.country_code,
        code: response.data.data.country_code,
        image: response.data.data.country_image,
      }
      name_ar.value = response.data.data.name_ar;
      name_en.value = response.data.data.name_en;
      selectedCity.value = response.data.data.city;
      phone.value = response.data.data.phone;
      profileImg.value = response.data.data.image;
      lat.value = response.data.data.lat || 1;
      lng.value = response.data.data.lng || 1;
      address.value = response.data.data.map_desc ;
      commercial_id.value = response.data.data.commercial_id;
      bio_ar.value = response.data.data.bio_ar;
      bio_en.value = response.data.data.bio_en;
      center.value.lat = Number(response.data.data.lat);
      center.value.lng = Number(response.data.data.lng);
    });
}

function getAddess(e) {
  address.value = e.address;
  lat.value = e.info.geometry.location.lat();
  lng.value = e.info.geometry.location.lng();
}
function getCities() {
  axios.get("/cities").then((response) => {
    cities.value = response.data.data;
  });
}
function getCountries() {
  axios.get("/countries").then((response) => {
    countries.value = response.data.data;
  });
}

function changeLocation() {
  disabled.value = true;
  const fd = new FormData();

  fd.append("lat", lat.value);
  fd.append("lng", lng.value);
  fd.append("map_desc", address.value);

  axios
    .post("/manager/update-location?_method=put", fd, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then((response) => {
      if (response.data?.key == "success") {
        showMap.value = false;
      } else {
        toast.add({
          severity: "error",
          detail: `${response.data.msg}`,
          life: 3000,
        });
      }
      disabled.value = false;
    });
}
function updateProfile() {
  disabled.value = true;
  const fd = new FormData(form.value.$el);
  // fd.append("type", SendedVal.value);
  fd.append("country_code", selectedCountry.value?.key);
  if (selectedCity.value) {
    fd.append("city_id", selectedCity.value.id);
  }
  fd.append("lang", localStorage.getItem("lang"));
  fd.append("lat", lat.value);
  fd.append("lng", lng.value);
  // fd.append("type", lng.value);
  fd.append("map_desc", address.value);

  axios
    .post("/manager/update-profile?_method=put", fd, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then((response) => {
      if (response.data.key == "success") {
        showSuccess.value = true;
        localStorage.setItem("userImg", response.data.data.image);
        localStorage.setItem("userName", response.data.data.name);
        document.querySelector(".userName").innerHTML = response.data.data.name;
        document.querySelector(".userImage").src =
          response.data.data.image;
      } else {
        toast.add({
          severity: "error",
          detail: `${response.data.msg}`,
          life: 3000,
        });
      }
      disabled.value = false;
    });
}

function validProfile() {
  if (valid.value) {
    updateProfile();
  } else {
    scrollToDanger();
  }
}

function scrollToDanger() {
  var element = document.querySelector(".v-input--error");
  if (element) {
    element.querySelector("input").focus();
  }
}

// uploadImage
function uploadImage(e) {
  const file = e.target.files[0];
  if (e.target.files[0]) {
    profileImg.value = URL.createObjectURL(file);
  } else {
    profileImg.value = require("../assets/imgs/natural-marble-pattern-background.png");
  }
}

// lifecycle hooks
onMounted(async () => {
  getCities();
  getCountries();
  await getProfile();
});
</script>
